exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1aEnFGRrIv9LAGPh9ztnGE {\n  height: 70vh;\n  padding: 0;\n  margin: 0; }\n", "", {"version":3,"sources":["/codebuild/output/src374373112/src/src/common/components/iframe-viewer/iframe-viewer.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,UAAU,EAAE","file":"iframe-viewer.scss","sourcesContent":[".checkout-frame {\n  height: 70vh;\n  padding: 0;\n  margin: 0; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"checkout-frame": "_1aEnFGRrIv9LAGPh9ztnGE",
	"checkoutFrame": "_1aEnFGRrIv9LAGPh9ztnGE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"namedExport":true,"camelCase":true,"modules":true,"sourceMap":true,"importLoaders":2,"localIdentname":"[name]__[local]__[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/common/components/iframe-viewer/iframe-viewer.scss
// module id = 972
// module chunks = 9